export const LOGIN_SUCCESS                = 'LOGIN_SUCCESS';
export const LOGIN_FAILED                 = 'LOGIN_FAILED';
export const LOGOUT                       = 'LOGOUT';

export const VERIFICATION_SUCCESS         = 'VERIFICATION_SUCCESS';
export const VERIFICATION_FAILED          = 'VERIFICATION_FAILED';

export const FETCH_SUBSCRIPTIONS_SUCCESS  = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILED   = 'FETCH_SUBSCRIPTIONS_FAILED';

export const FETCH_PUB_SUBSCRIPTIONS      = 'FETCH_PUB_SUBSCRIPTIONS';

export const FETCH_QUESTIONS_SUCCESS      = 'FETCH_QUESTIONS_SUCCESS';
export const FETCH_QUESTIONS_FAILED       = 'FETCH_QUESTIONS_FAILED';

export const FETCH_PUB_QUESTIONS_SUCCESS  = 'FETCH_PUB_QUESTIONS_SUCCESS';
export const FETCH_PUB_QUESTIONS_FAILED   = 'FETCH_PUB_QUESTIONS_FAILED';

export const SHOW_MODAL                   = 'SHOW_MODAL';
export const HIDE_MODAL                   = 'HIDE_MODAL';

export const SET_QUESTION                 = 'SET_QUESTION';

export const REGISTER_ACCOUNT_SUCCESS     = 'REGISTER_ACCOUNT_SUCCESS';
export const REGISTER_ACCOUNT_FAILURE     = 'REGISTER_ACCOUNT_FAILURE';

export const SET_COMPANY                  = 'SET_COMPANY';

export const PAY_SUBSCRIPTION_SUCCESS     = 'PAY_SUBSCRIPTION_SUCCESS';
export const PAY_SUBSCRIPTION_FAILED      = 'PAY_SUBSCRIPTION_FAILED';

export const SHOW_NOTIF                   = 'SHOW_NOTIF';
export const CLOSE_NOTIF                  = 'CLOSE_NOTIF';


// WEBPACK FOOTER //
// ./src/store/types.js